module.exports = __webpack_public_path__ + "img/L4.073f7211.jpg";